import { Button, InputGroup, Label, TextField } from "~/lib/heroui"
import { Eye, EyeOff } from "lucide-react"
import { useState } from "react"

type PasswordFieldProps = {
  autoComplete: "new-password" | "current-password"
  autoFocus?: boolean
  isRequired?: boolean
  label: string
  minLength?: number
  name: string
  placeholder?: string
}

export function PasswordField({
  autoComplete,
  autoFocus,
  isRequired,
  label,
  minLength,
  name,
  placeholder = "••••••••",
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false)

  return (
    <TextField isRequired={isRequired} name={name}>
      <Label>{label}</Label>
      <InputGroup variant="secondary">
        <InputGroup.Input
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          minLength={minLength}
          placeholder={placeholder}
          type={visible ? "text" : "password"}
        />
        <InputGroup.Suffix className="pr-0">
          <Button
            isIconOnly
            aria-label={visible ? "隐藏密码" : "显示密码"}
            size="sm"
            type="button"
            variant="ghost"
            onPress={() => setVisible((current) => !current)}
          >
            {visible ? (
              <Eye aria-hidden className="size-4" />
            ) : (
              <EyeOff aria-hidden className="size-4" />
            )}
          </Button>
        </InputGroup.Suffix>
      </InputGroup>
    </TextField>
  )
}
